/* 
 * 文件名: assets/dhl-shipping-calculator.js
 * 方案2版本 - 完整的JavaScript逻辑，修复了运费计算
 */
class DHLShippingCalculator {
  constructor() {
    this.allProducts = [];
    this.filteredProducts = [];
    this.currentPage = 1;
    this.itemsPerPage = 50;
    this.selectedProducts = new Map();
    this.settings = {};
    
    this.init();
  }

  init() {
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeCalculator());
    } else {
      this.initializeCalculator();
    }
  }

  initializeCalculator() {
    try {
      // 加载产品数据
      this.loadProductData();
      
      // 绑定事件
      this.bindEvents();
      
      // 只更新计数器和选择状态，不隐藏产品
      this.updateCounters();
      this.updateSelectedSummary();
      
      console.log(`🔥 Asset Calculator initialized with ${this.allProducts.length} products`);
    } catch (error) {
      console.error('Failed to initialize DHL Calculator:', error);
    }
  }

  loadProductData() {
    const dataElement = document.getElementById('products-data');
    if (dataElement) {
      try {
        const data = JSON.parse(dataElement.textContent);
        this.allProducts = data.products || [];
        this.settings = data.settings || {};
        this.itemsPerPage = this.settings.limitPerPage || 50;
        this.filteredProducts = [...this.allProducts];
        
        console.log(`Loaded ${this.allProducts.length} products`);
      } catch (error) {
        console.error('Failed to parse product data:', error);
      }
    } else {
      console.error('Product data element not found');
    }
  }

  bindEvents() {
    // 搜索功能
    const searchInput = document.getElementById('product-search');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => this.handleSearch(e.target.value));
    }

    // 清除搜索按钮
    const clearSearchBtn = document.getElementById('clear-search-btn');
    if (clearSearchBtn) {
      clearSearchBtn.addEventListener('click', () => this.resetFilters());
    }

    // 过滤器
    const brandFilter = document.getElementById('brand-filter');
    if (brandFilter) {
      brandFilter.addEventListener('change', (e) => this.handleBrandFilter(e.target.value));
    }

    const categoryFilter = document.getElementById('category-filter');
    if (categoryFilter) {
      categoryFilter.addEventListener('change', (e) => this.handleCategoryFilter(e.target.value));
    }

    // 全选功能
    const selectAllBtn = document.getElementById('select-all');
    if (selectAllBtn) {
      selectAllBtn.addEventListener('change', (e) => this.toggleSelectAll(e.target.checked));
    }

    // 重置过滤器按钮
    const resetFiltersBtn = document.getElementById('reset-filters-btn');
    if (resetFiltersBtn) {
      resetFiltersBtn.addEventListener('click', () => this.resetFilters());
    }

    // 产品选择事件（事件委托）
    const tbody = document.getElementById('products-tbody');
    if (tbody) {
      // 产品选择框事件
      tbody.addEventListener('change', (e) => {
        if (e.target.classList.contains('product-checkbox')) {
          console.log('Checkbox changed:', e.target.value);
          this.handleProductSelection(e.target);
        } else if (e.target.classList.contains('quantity-input')) {
          console.log('Quantity changed:', e.target.value);
          this.handleQuantityChange(e.target);
        }
      });

      // 数量按钮事件
      tbody.addEventListener('click', (e) => {
        if (e.target.classList.contains('quantity-btn') || e.target.closest('.quantity-btn')) {
          const button = e.target.closest('.quantity-btn') || e.target;
          this.handleQuantityButton(button);
        }
      });
    }

    // 计算按钮
    const calculateBtn = document.getElementById('calculate-btn');
    if (calculateBtn) {
      calculateBtn.addEventListener('click', () => this.proceedToShipping());
    }

    console.log('Events bound successfully');
  }

  handleSearch(searchTerm) {
    this.applyFilters();
  }

  handleBrandFilter(brand) {
    this.applyFilters();
  }

  handleCategoryFilter(category) {
    console.log('Category filter changed to:', category);
    
    // 如果选择了具体分类，需要筛选对应的产品
    if (category && category !== '') {
      // 获取所有产品行
      const allRows = document.querySelectorAll('.product-row');
      let visibleCount = 0;

      allRows.forEach(row => {
        // 首先检查产品的data-category属性
        const rowCategory = row.dataset.category || '';
        
        // 也从产品数据中查找（支持collection-based分类）
        const productId = row.dataset.productId;
        let productCategory = rowCategory;
        
        // 如果有产品数据，尝试从中获取分类信息
        if (this.allProducts && this.allProducts.length > 0) {
          const productData = this.allProducts.find(p => p.id.toString() === productId);
          if (productData && productData.category) {
            productCategory = productData.category;
          }
        }
        
        // 判断是否匹配选择的分类
        const matchesCategory = productCategory === category;
        
        if (matchesCategory) {
          row.style.display = 'table-row';
          row.classList.remove('hidden');
          visibleCount++;
        } else {
          row.style.display = 'none';
          row.classList.add('hidden');
        }
      });

      // 更新计数器
      this.updateFilteredCount(visibleCount);

      // 显示/隐藏无产品提示
      const noProductsDiv = document.getElementById('no-products-found');
      const tableContainer = document.querySelector('.products-table-container');
      
      if (visibleCount === 0) {
        if (noProductsDiv) noProductsDiv.style.display = 'block';
        if (tableContainer) tableContainer.style.display = 'none';
      } else {
        if (noProductsDiv) noProductsDiv.style.display = 'none';
        if (tableContainer) tableContainer.style.display = 'block';
      }
      
      console.log(`Category filter applied: ${category}, visible products: ${visibleCount}`);
    } else {
      // 如果选择"All Categories"，应用其他筛选器
      this.applyFilters();
    }
  }

  applyFilters() {
    const searchTerm = (document.getElementById('product-search')?.value || '').toLowerCase();
    const selectedBrand = (document.getElementById('brand-filter')?.value || '').toLowerCase();
    const selectedCategory = (document.getElementById('category-filter')?.value || '').toLowerCase();

    // 获取所有产品行
    const allRows = document.querySelectorAll('.product-row');
    let visibleCount = 0;

    allRows.forEach(row => {
      const title = (row.dataset.title || '').toLowerCase();
      const vendor = (row.dataset.vendor || '').toLowerCase();
      const tags = (row.dataset.tags || '').toLowerCase();
      const sku = (row.dataset.sku || '').toLowerCase();
      
      // 🔥 改进的分类匹配逻辑
      let rowCategory = (row.dataset.category || '').toLowerCase();
      
      // 如果有产品数据，尝试从中获取更准确的分类信息
      const productId = row.dataset.productId;
      if (this.allProducts && this.allProducts.length > 0) {
        const productData = this.allProducts.find(p => p.id.toString() === productId);
        if (productData && productData.category) {
          rowCategory = productData.category.toLowerCase();
        }
      }

      // 搜索过滤
      const matchesSearch = !searchTerm || 
        title.includes(searchTerm) ||
        vendor.includes(searchTerm) ||
        sku.includes(searchTerm) ||
        tags.includes(searchTerm);

      // 品牌过滤
      const matchesBrand = !selectedBrand || vendor.includes(selectedBrand);

      // 🔥 改进的分类过滤
      const matchesCategory = !selectedCategory || rowCategory === selectedCategory;

      if (matchesSearch && matchesBrand && matchesCategory) {
        row.style.display = 'table-row';
        row.classList.remove('hidden');
        visibleCount++;
      } else {
        row.style.display = 'none';
        row.classList.add('hidden');
      }
    });

    // 更新计数器
    this.updateFilteredCount(visibleCount);

    // 显示/隐藏无产品提示
    const noProductsDiv = document.getElementById('no-products-found');
    const tableContainer = document.querySelector('.products-table-container');
    
    if (visibleCount === 0) {
      if (noProductsDiv) noProductsDiv.style.display = 'block';
      if (tableContainer) tableContainer.style.display = 'none';
    } else {
      if (noProductsDiv) noProductsDiv.style.display = 'none';
      if (tableContainer) tableContainer.style.display = 'block';
    }
    
    console.log(`Filters applied - Search: "${searchTerm}", Brand: "${selectedBrand}", Category: "${selectedCategory}", Visible: ${visibleCount}`);
  }

  updateFilteredCount(count) {
    const showingCount = document.getElementById('showing-count');
    if (showingCount) showingCount.textContent = count;
  }

  updateCounters() {
    const showingCount = document.getElementById('showing-count');
    const totalProducts = document.getElementById('total-products');

    if (showingCount) showingCount.textContent = this.allProducts.length;
    if (totalProducts) totalProducts.textContent = this.allProducts.length;
  }

  updateSelectedSummary() {
    const selectedSummary = document.getElementById('selected-summary');
    const selectedCount = document.getElementById('selected-count');
    const totalWeightSummary = document.getElementById('total-weight-summary');
    const totalValueSummary = document.getElementById('total-value-summary');
    const calculateBtn = document.getElementById('calculate-btn');

    const hasSelection = this.selectedProducts.size > 0;

    if (selectedSummary) {
      selectedSummary.style.display = hasSelection ? 'block' : 'none';
    }

    if (hasSelection) {
      let totalWeight = 0;
      let totalValue = 0;

      this.selectedProducts.forEach((data, productId) => {
        totalWeight += data.weight * data.quantity;
        totalValue += data.price * data.quantity;
      });

      if (selectedCount) selectedCount.textContent = this.selectedProducts.size;
      if (totalWeightSummary) totalWeightSummary.textContent = `${totalWeight}g`;
      if (totalValueSummary) totalValueSummary.textContent = `$${totalValue.toFixed(2)}`;
      
      console.log(`Selected: ${this.selectedProducts.size} products, Weight: ${totalWeight}g, Value: $${totalValue.toFixed(2)}`);
    }

    if (calculateBtn) {
      calculateBtn.disabled = !hasSelection;
    }
  }

  handleProductSelection(checkbox) {
    const productId = checkbox.value;
    const row = checkbox.closest('.product-row');
    const quantityInput = row.querySelector('.quantity-input');

    console.log(`Product ${productId} selection changed:`, checkbox.checked);

    if (checkbox.checked) {
      // 添加到选择列表
      let quantity = parseInt(quantityInput?.value) || 1;
      if (quantity <= 0) {
        quantity = 1;
        if (quantityInput) quantityInput.value = 1;
      }
      
      this.selectedProducts.set(productId, {
        id: productId,
        title: checkbox.dataset.title,
        price: parseFloat(checkbox.dataset.price),
        weight: parseFloat(checkbox.dataset.weight) || 0,
        quantity: quantity
      });
      
      console.log(`Added product ${productId}:`, this.selectedProducts.get(productId));
    } else {
      // 从选择列表移除
      this.selectedProducts.delete(productId);
      if (quantityInput) quantityInput.value = 0;
      
      console.log(`Removed product ${productId}`);
    }

    this.updateSelectedSummary();
  }

  handleQuantityChange(input) {
    const productId = input.dataset.productId;
    const checkbox = document.getElementById(`product_${productId}`);
    const quantity = parseInt(input.value) || 0;

    console.log(`Quantity changed for product ${productId}:`, quantity);

    if (quantity > 0) {
      if (checkbox) checkbox.checked = true;
      this.selectedProducts.set(productId, {
        id: productId,
        title: checkbox?.dataset.title || '',
        price: parseFloat(checkbox?.dataset.price) || 0,
        weight: parseFloat(checkbox?.dataset.weight) || 0,
        quantity: quantity
      });
      
      console.log(`Updated product ${productId}:`, this.selectedProducts.get(productId));
    } else {
      if (checkbox) checkbox.checked = false;
      this.selectedProducts.delete(productId);
      
      console.log(`Removed product ${productId} (quantity 0)`);
    }

    this.updateSelectedSummary();
  }

  handleQuantityButton(button) {
    const row = button.closest('.product-row');
    const input = row.querySelector('.quantity-input');
    const isPlus = button.classList.contains('plus');
    const change = isPlus ? 1 : -1;
    
    const currentValue = parseInt(input.value) || 0;
    const maxValue = parseInt(input.max) || 100;
    const newValue = Math.max(0, Math.min(maxValue, currentValue + change));
    
    input.value = newValue;
    input.dispatchEvent(new Event('change'));
  }

  toggleSelectAll(checked) {
    // 获取当前可见的所有产品
    const visibleRows = document.querySelectorAll('.product-row[style*="table-row"], .product-row:not([style*="none"])');

    visibleRows.forEach(row => {
      const checkbox = row.querySelector('.product-checkbox');
      const quantityInput = row.querySelector('.quantity-input');
      
      if (checkbox) {
        checkbox.checked = checked;
        
        if (checked) {
          if (quantityInput) quantityInput.value = 1;
          
          this.selectedProducts.set(checkbox.value, {
            id: checkbox.value,
            title: checkbox.dataset.title,
            price: parseFloat(checkbox.dataset.price),
            weight: parseFloat(checkbox.dataset.weight) || 0,
            quantity: 1
          });
        } else {
          if (quantityInput) quantityInput.value = 0;
          this.selectedProducts.delete(checkbox.value);
        }
      }
    });

    this.updateSelectedSummary();
  }

  resetFilters() {
    // 重置搜索
    const searchInput = document.getElementById('product-search');
    if (searchInput) searchInput.value = '';

    // 重置过滤器
    const brandFilter = document.getElementById('brand-filter');
    if (brandFilter) brandFilter.value = '';

    const categoryFilter = document.getElementById('category-filter');
    if (categoryFilter) categoryFilter.value = '';

    // 显示所有产品
    const allRows = document.querySelectorAll('.product-row');
    allRows.forEach(row => {
      row.style.display = 'table-row';
      row.classList.remove('hidden');
    });

    // 更新计数器
    this.updateCounters();

    // 隐藏无产品提示
    const noProductsDiv = document.getElementById('no-products-found');
    const tableContainer = document.querySelector('.products-table-container');
    
    if (noProductsDiv) noProductsDiv.style.display = 'none';
    if (tableContainer) tableContainer.style.display = 'block';
  }

  proceedToShipping() {
    console.log('Proceed to shipping clicked. Selected products:', this.selectedProducts.size);
    
    if (this.selectedProducts.size === 0) {
      alert('请至少选择一个产品');
      return;
    }

    // 将选择的产品数据存储到sessionStorage
    const selectedData = Array.from(this.selectedProducts.values());
    sessionStorage.setItem('dhl_selected_products', JSON.stringify(selectedData));

    console.log('Selected products data:', selectedData);

    // 滚动到下一个section或显示运费计算表单
    this.showShippingForm();
  }

  showShippingForm() {
    // 查找下一个section或创建运费计算表单
    const nextSection = document.querySelector('.shipping-destination, .dhl-rates-config');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      // 如果没有下一个section，显示内联的运费计算表单
      this.createInlineShippingForm();
    }
  }

  createInlineShippingForm() {
    const calculatorSection = document.getElementById('dhl-shipping-calculator');
    if (!calculatorSection) return;

    // 检查是否已经存在表单
    let shippingForm = document.getElementById('inline-shipping-form');
    if (shippingForm) {
      shippingForm.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    // 创建运费计算表单
    shippingForm = document.createElement('div');
    shippingForm.id = 'inline-shipping-form';
    shippingForm.className = 'inline-shipping-form';
    
    shippingForm.innerHTML = `
      <div class="shipping-form-container">
        <h3>🌍 Shipping Destination</h3>
        <div class="destination-selection">
          <div class="form-group">
            <label for="country">Country/Region:</label>
            <select id="country" name="country" required>
              <option value="">Select Country</option>
              <option value="HK">Hong Kong</option>
              <option value="MO">Macao</option>
              <option value="KR">South Korea</option>
              <option value="TW">Taiwan</option>
              <option value="JP">Japan</option>
              <option value="BN">Brunei</option>
              <option value="ID">Indonesia</option>
              <option value="KH">Cambodia</option>
              <option value="LA">Laos</option>
              <option value="MY">Malaysia</option>
              <option value="PH">Philippines</option>
              <option value="SG">Singapore</option>
              <option value="TH">Thailand</option>
              <option value="VN">Vietnam</option>
              <option value="AU">Australia</option>
              <option value="NZ">New Zealand</option>
              <option value="CA">Canada</option>
              <option value="MX">Mexico</option>
              <option value="US">United States</option>
              <option value="AD">Andorra</option>
              <option value="AT">Austria</option>
              <option value="BE">Belgium</option>
              <option value="BG">Bulgaria</option>
              <option value="CH">Switzerland</option>
              <option value="CY">Cyprus</option>
              <option value="CZ">Czech Republic</option>
              <option value="DE">Germany</option>
              <option value="DK">Denmark</option>
              <option value="EE">Estonia</option>
              <option value="ES">Spain</option>
              <option value="FI">Finland</option>
              <option value="FR">France</option>
              <option value="GB">United Kingdom</option>
              <option value="GG">Guernsey</option>
              <option value="GI">Gibraltar</option>
              <option value="GL">Greenland</option>
              <option value="GR">Greece</option>
              <option value="HR">Croatia</option>
              <option value="HU">Hungary</option>
              <option value="IC">Canary Islands</option>
              <option value="IE">Ireland</option>
              <option value="IN">India</option>
              <option value="IS">Iceland</option>
              <option value="IT">Italy</option>
              <option value="JE">Jersey</option>
              <option value="LI">Liechtenstein</option>
              <option value="LT">Lithuania</option>
              <option value="LU">Luxembourg</option>
              <option value="LV">Latvia</option>
              <option value="MC">Monaco</option>
              <option value="MT">Malta</option>
              <option value="NL">Netherlands</option>
              <option value="NO">Norway</option>
              <option value="PL">Poland</option>
              <option value="PT">Portugal</option>
              <option value="SE">Sweden</option>
              <option value="SI">Slovenia</option>
              <option value="SK">Slovakia</option>
              <option value="SM">San Marino</option>
              <option value="VA">Vatican City</option>
              <option value="AE">United Arab Emirates</option>
              <option value="BH">Bahrain</option>
              <option value="EG">Egypt</option>
              <option value="IL">Israel</option>
              <option value="KW">Kuwait</option>
              <option value="SA">Saudi Arabia</option>
              <option value="TR">Turkey</option>
              <option value="AF">Afghanistan</option>
              <option value="AG">Antigua and Barbuda</option>
              <option value="AI">Anguilla</option>
              <option value="AL">Albania</option>
              <option value="AM">Armenia</option>
              <option value="AO">Angola</option>
              <option value="AR">Argentina</option>
              <option value="AS">American Samoa</option>
              <option value="AW">Aruba</option>
              <option value="AZ">Azerbaijan</option>
              <option value="BA">Bosnia and Herzegovina</option>
              <option value="BB">Barbados</option>
              <option value="BD">Bangladesh</option>
              <option value="BF">Burkina Faso</option>
              <option value="BI">Burundi</option>
              <option value="BJ">Benin</option>
              <option value="BM">Bermuda</option>
              <option value="BO">Bolivia</option>
              <option value="BR">Brazil</option>
              <option value="BS">Bahamas</option>
              <option value="BT">Bhutan</option>
              <option value="BW">Botswana</option>
              <option value="BY">Belarus</option>
              <option value="BZ">Belize</option>
              <option value="CD">Democratic Republic of the Congo</option>
              <option value="CF">Central African Republic</option>
              <option value="CG">Congo</option>
              <option value="CI">Ivory Coast</option>
              <option value="CK">Cook Islands</option>
              <option value="CL">Chile</option>
              <option value="CM">Cameroon</option>
              <option value="CO">Colombia</option>
              <option value="CR">Costa Rica</option>
              <option value="CU">Cuba</option>
              <option value="CV">Cape Verde</option>
              <option value="DJ">Djibouti</option>
              <option value="DM">Dominica</option>
              <option value="DO">Dominican Republic</option>
              <option value="DZ">Algeria</option>
              <option value="EC">Ecuador</option>
              <option value="ER">Eritrea</option>
              <option value="ET">Ethiopia</option>
              <option value="FJ">Fiji</option>
              <option value="FK">Falkland Islands</option>
              <option value="FM">Micronesia</option>
              <option value="FO">Faroe Islands</option>
              <option value="GA">Gabon</option>
              <option value="GD">Grenada</option>
              <option value="GE">Georgia</option>
              <option value="GF">French Guiana</option>
              <option value="GH">Ghana</option>
              <option value="GM">Gambia</option>
              <option value="GN">Guinea</option>
              <option value="GP">Guadeloupe</option>
              <option value="GQ">Equatorial Guinea</option>
              <option value="GT">Guatemala</option>
              <option value="GU">Guam</option>
              <option value="GW">Guinea-Bissau</option>
              <option value="GY">Guyana</option>
              <option value="HN">Honduras</option>
              <option value="HT">Haiti</option>
              <option value="IQ">Iraq</option>
              <option value="IR">Iran</option>
              <option value="JM">Jamaica</option>
              <option value="JO">Jordan</option>
              <option value="KE">Kenya</option>
              <option value="KG">Kyrgyzstan</option>
              <option value="KI">Kiribati</option>
              <option value="KM">Comoros</option>
              <option value="KN">Saint Kitts and Nevis</option>
              <option value="KP">North Korea</option>
              <option value="XK">Kosovo</option>
              <option value="KY">Cayman Islands</option>
              <option value="KZ">Kazakhstan</option>
              <option value="LB">Lebanon</option>
              <option value="LC">Saint Lucia</option>
              <option value="LK">Sri Lanka</option>
              <option value="LR">Liberia</option>
              <option value="LS">Lesotho</option>
              <option value="LY">Libya</option>
              <option value="MA">Morocco</option>
              <option value="MD">Moldova</option>
              <option value="ME">Montenegro</option>
              <option value="MG">Madagascar</option>
              <option value="MH">Marshall Islands</option>
              <option value="MK">North Macedonia</option>
              <option value="ML">Mali</option>
              <option value="MM">Myanmar</option>
              <option value="MN">Mongolia</option>
              <option value="MP">Northern Mariana Islands</option>
              <option value="MQ">Martinique</option>
              <option value="MR">Mauritania</option>
              <option value="MS">Montserrat</option>
              <option value="MU">Mauritius</option>
              <option value="MV">Maldives</option>
              <option value="MW">Malawi</option>
              <option value="MZ">Mozambique</option>
              <option value="NA">Namibia</option>
              <option value="NC">New Caledonia</option>
              <option value="NE">Niger</option>
              <option value="NG">Nigeria</option>
              <option value="NI">Nicaragua</option>
              <option value="NP">Nepal</option>
              <option value="NR">Nauru</option>
              <option value="NU">Niue</option>
              <option value="OM">Oman</option>
              <option value="PA">Panama</option>
              <option value="PE">Peru</option>
              <option value="PF">French Polynesia</option>
              <option value="PG">Papua New Guinea</option>
              <option value="PK">Pakistan</option>
              <option value="PR">Puerto Rico</option>
              <option value="PW">Palau</option>
              <option value="PY">Paraguay</option>
              <option value="QA">Qatar</option>
              <option value="RE">Reunion</option>
              <option value="RO">Romania</option>
              <option value="RS">Serbia</option>
              <option value="RU">Russia</option>
              <option value="RW">Rwanda</option>
              <option value="SB">Solomon Islands</option>
              <option value="SC">Seychelles</option>
              <option value="SD">Sudan</option>
              <option value="SH">Saint Helena</option>
              <option value="SL">Sierra Leone</option>
              <option value="SN">Senegal</option>
              <option value="SO">Somalia</option>
              <option value="SR">Suriname</option>
              <option value="SS">South Sudan</option>
              <option value="ST">Sao Tome and Principe</option>
              <option value="SV">El Salvador</option>
              <option value="SY">Syria</option>
              <option value="SZ">Eswatini</option>
              <option value="TC">Turks and Caicos Islands</option>
              <option value="TD">Chad</option>
              <option value="TG">Togo</option>
              <option value="TJ">Tajikistan</option>
              <option value="TL">East Timor</option>
              <option value="TM">Turkmenistan</option>
              <option value="TN">Tunisia</option>
              <option value="TO">Tonga</option>
              <option value="TT">Trinidad and Tobago</option>
              <option value="TV">Tuvalu</option>
              <option value="TZ">Tanzania</option>
              <option value="UA">Ukraine</option>
              <option value="UG">Uganda</option>
              <option value="UY">Uruguay</option>
              <option value="UZ">Uzbekistan</option>
              <option value="VC">Saint Vincent and the Grenadines</option>
              <option value="VE">Venezuela</option>
              <option value="VG">British Virgin Islands</option>
              <option value="VI">U.S. Virgin Islands</option>
              <option value="VU">Vanuatu</option>
              <option value="WS">Samoa</option>
              <option value="BQ">Bonaire</option>
              <option value="CW">Curacao</option>
              <option value="BL">Saint Barthelemy</option>
              <option value="SX">Sint Maarten</option>
              <option value="YE">Yemen</option>
              <option value="YT">Mayotte</option>
              <option value="ZA">South Africa</option>
              <option value="ZM">Zambia</option>
              <option value="ZW">Zimbabwe</option>
            </select>
          </div>
          
          <div class="form-group">
            <label for="postal_code">Postal/ZIP Code:</label>
            <input type="text" id="postal_code" name="postal_code" placeholder="Enter postal code">
          </div>
        </div>
        
        <button type="button" class="calculate-shipping-btn" onclick="dhlCalculator.calculateShipping()">
          <i class="las la-calculator"></i>
          Calculate DHL Express Shipping
        </button>
        
        <div id="shipping-results" class="results-section" style="display: none;">
          <h3>📋 Shipping Calculation Results</h3>
          <div class="results-content">
            <div class="result-item">
              <span class="label">Total Weight:</span>
              <span id="total-weight" class="value">0g</span>
            </div>
            <div class="result-item">
              <span class="label">Total Product Value:</span>
              <span id="total-value" class="value">$0.00</span>
            </div>
            <div class="result-item">
              <span class="label">Destination:</span>
              <span id="destination" class="value">-</span>
            </div>
            <div class="result-item shipping-cost">
              <span class="label">DHL Express Shipping Cost:</span>
              <span id="shipping-cost" class="value">$0.00</span>
            </div>
            <div class="result-item">
              <span class="label">Estimated Delivery:</span>
              <span id="delivery-time" class="value">1-3 business days</span>
            </div>
          </div>
        </div>
      </div>
    `;

    // 添加样式
    const style = document.createElement('style');
    style.textContent = `
      .inline-shipping-form {
        margin-top: 40px;
        padding: 30px;
        background: #f8f9fa;
        border-radius: 12px;
        border: 2px solid #e9ecef;
      }
      
      .shipping-form-container h3 {
        margin-bottom: 25px;
        color: #2c3e50;
        font-size: 1.5rem;
      }
      
      .destination-selection {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        margin-bottom: 30px;
      }
      
      .form-group label {
        display: block;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 8px;
      }
      
      .form-group select,
      .form-group input {
        width: 100%;
        padding: 12px;
        border: 2px solid #e9ecef;
        border-radius: 8px;
        font-size: 16px;
        height: 48px !important;
        line-height: 1.4 !important;
        box-sizing: border-box !important;
        vertical-align: middle !important;
      }
      
      .calculate-shipping-btn {
        width: 100%;
        background: linear-gradient(135deg, #27ae60, #229954);
        color: white;
        border: none;
        padding: 18px 30px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      
      .calculate-shipping-btn:hover {
        background: linear-gradient(135deg, #229954, #1e8449);
        transform: translateY(-2px);
      }
      
      .results-section {
        margin-top: 30px;
        padding: 25px;
        background: #e8f5e8;
        border-radius: 10px;
      }
      
      .results-section h3 {
        color: #27ae60;
        margin-bottom: 20px;
      }
      
      .result-item {
        display: flex;
        justify-content: space-between;
        padding: 12px 0;
        border-bottom: 1px solid #d5e8d5;
      }
      
      .result-item:last-child {
        border-bottom: none;
      }
      
      .result-item .label {
        font-weight: 600;
        color: #2c3e50;
      }
      
      .result-item .value {
        font-weight: 700;
        color: #27ae60;
      }
      
      .shipping-cost {
        background: #d5e8d5;
        padding: 15px;
        border-radius: 8px;
        margin: 10px 0;
      }
      
      .shipping-cost .value {
        font-size: 1.3rem;
      }
      
      @media (max-width: 768px) {
        .destination-selection {
          grid-template-columns: 1fr;
        }
      }
    `;
    
    document.head.appendChild(style);
    calculatorSection.appendChild(shippingForm);
    shippingForm.scrollIntoView({ behavior: 'smooth' });
  }

  calculateShipping() {
    const country = document.getElementById('country')?.value;
    if (!country) {
      alert('请选择目的地国家');
      return;
    }

    if (this.selectedProducts.size === 0) {
      alert('请选择产品');
      return;
    }

    // 计算总重量和总价值
    let totalWeight = 0;
    let totalValue = 0;

    this.selectedProducts.forEach(product => {
      totalWeight += product.weight * product.quantity;
      totalValue += product.price * product.quantity;
    });

    // 计算运费
    const shippingCost = this.calculateDHLCost(totalWeight, country);
    const deliveryTime = this.getDHLDeliveryTime(country);

    // 显示结果
    this.displayResults(totalWeight, totalValue, country, shippingCost, deliveryTime);
  }

  calculateDHLCost(weight, country) {
    // 🔥 完整的DHL费率配置 - 修复133kg等重量的正确计算
    const weightRanges = [
      { min: 0, max: 500, price: 26.00 },        // 0-500g
      { min: 501, max: 1000, price: 35.00 },     // 501g-1kg
      { min: 1001, max: 1500, price: 44.00 },    // 1-1.5kg
      { min: 1501, max: 2000, price: 52.00 },    // 1.5-2kg
      { min: 2001, max: 2500, price: 61.00 },    // 2-2.5kg
      { min: 2501, max: 3000, price: 69.00 },    // 2.5-3kg
      { min: 3001, max: 3500, price: 78.00 },    // 3-3.5kg
      { min: 3501, max: 4000, price: 86.00 },    // 3.5-4kg
      { min: 4001, max: 4500, price: 95.00 },    // 4-4.5kg
      { min: 4501, max: 5000, price: 103.00 },   // 4.5-5kg
      { min: 5001, max: 5500, price: 111.00 },   // 5-5.5kg
      { min: 5501, max: 6000, price: 120.00 },   // 5.5-6kg
      { min: 6001, max: 6500, price: 128.00 },   // 6-6.5kg
      { min: 6501, max: 7000, price: 137.00 },   // 6.5-7kg
      { min: 7001, max: 7500, price: 145.00 },   // 7-7.5kg
      { min: 7501, max: 8000, price: 153.00 },   // 7.5-8kg
      { min: 8001, max: 8500, price: 162.00 },   // 8-8.5kg
      { min: 8501, max: 9000, price: 170.00 },   // 8.5-9kg
      { min: 9001, max: 9500, price: 179.00 },   // 9-9.5kg
      { min: 9501, max: 10000, price: 187.00 },  // 9.5-10kg
      { min: 10001, max: 10500, price: 195.00 }, // 10-10.5kg
      { min: 10501, max: 11000, price: 203.00 }, // 10.5-11kg
      { min: 11001, max: 11500, price: 211.00 }, // 11-11.5kg
      { min: 11501, max: 12000, price: 219.00 }, // 11.5-12kg
      { min: 12001, max: 12500, price: 227.00 }, // 12-12.5kg
      { min: 12501, max: 13000, price: 235.00 }, // 12.5-13kg
      { min: 13001, max: 13500, price: 242.00 }, // 13-13.5kg
      { min: 13501, max: 14000, price: 250.00 }, // 13.5-14kg
      { min: 14001, max: 14500, price: 258.00 }, // 14-14.5kg
      { min: 14501, max: 15000, price: 266.00 }, // 14.5-15kg
      { min: 15001, max: 15500, price: 274.00 }, // 15-15.5kg
      { min: 15501, max: 16000, price: 282.00 }, // 15.5-16kg
      { min: 16001, max: 16500, price: 290.00 }, // 16-16.5kg
      { min: 16501, max: 17000, price: 298.00 }, // 16.5-17kg
      { min: 17001, max: 17500, price: 306.00 }, // 17-17.5kg
      { min: 17501, max: 18000, price: 314.00 }, // 17.5-18kg
      { min: 18001, max: 18500, price: 321.00 }, // 18-18.5kg
      { min: 18501, max: 19000, price: 329.00 }, // 18.5-19kg
      { min: 19001, max: 19500, price: 337.00 }, // 19-19.5kg
      { min: 19501, max: 20000, price: 345.00 }, // 19.5-20kg
      { min: 20001, max: 20500, price: 210.00 }, // 20-20.5kg
      { min: 20501, max: 21000, price: 214.00 }, // 20.5-21kg
      { min: 21001, max: 21500, price: 217.00 }, // 21-21.5kg
      { min: 21501, max: 22000, price: 220.00 }, // 21.5-22kg
      { min: 22001, max: 22500, price: 223.00 }, // 22-22.5kg
      { min: 22501, max: 23000, price: 227.00 }, // 22.5-23kg
      { min: 23001, max: 23500, price: 230.00 }, // 23-23.5kg
      { min: 23501, max: 24000, price: 233.00 }, // 23.5-24kg
      { min: 24001, max: 24500, price: 236.00 }, // 24-24.5kg
      { min: 24501, max: 25000, price: 240.00 }, // 24.5-25kg
      { min: 25001, max: 25500, price: 243.00 }, // 25-25.5kg
      { min: 25501, max: 26000, price: 246.00 }, // 25.5-26kg
      { min: 26001, max: 26500, price: 249.00 }, // 26-26.5kg
      { min: 26501, max: 27000, price: 253.00 }, // 26.5-27kg
      { min: 27001, max: 27500, price: 256.00 }, // 27-27.5kg
      { min: 27501, max: 28000, price: 259.00 }, // 27.5-28kg
      { min: 28001, max: 28500, price: 262.00 }, // 28-28.5kg
      { min: 28501, max: 29000, price: 266.00 }, // 28.5-29kg
      { min: 29001, max: 29500, price: 269.00 }, // 29-29.5kg
      { min: 29501, max: 30000, price: 272.00 }, // 29.5-30kg
      { min: 30001, max: 31000, price: 289.00 }, // 30-31kg
      { min: 31001, max: 32000, price: 299.00 }, // 31-32kg
      { min: 32001, max: 33000, price: 309.00 }, // 32-33kg
      { min: 33001, max: 34000, price: 319.00 }, // 33-34kg
      { min: 34001, max: 35000, price: 329.00 }, // 34-35kg
      { min: 35001, max: 36000, price: 339.00 }, // 35-36kg
      { min: 36001, max: 37000, price: 349.00 }, // 36-37kg
      { min: 37001, max: 38000, price: 359.00 }, // 37-38kg
      { min: 38001, max: 39000, price: 369.00 }, // 38-39kg
      { min: 39001, max: 40000, price: 379.00 }, // 39-40kg
      { min: 40001, max: 41000, price: 389.00 }, // 40-41kg
      { min: 41001, max: 42000, price: 399.00 }, // 41-42kg
      { min: 42001, max: 43000, price: 409.00 }, // 42-43kg
      { min: 43001, max: 44000, price: 419.00 }, // 43-44kg
      { min: 44001, max: 45000, price: 429.00 }, // 44-45kg
      { min: 45001, max: 46000, price: 439.00 }, // 45-46kg
      { min: 46001, max: 47000, price: 449.00 }, // 46-47kg
      { min: 47001, max: 48000, price: 459.00 }, // 47-48kg
      { min: 48001, max: 49000, price: 469.00 }, // 48-49kg
      { min: 49001, max: 50000, price: 479.00 }, // 49-50kg
      { min: 50001, max: 51000, price: 489.00 }, // 50-51kg
      { min: 51001, max: 52000, price: 499.00 }, // 51-52kg
      { min: 52001, max: 53000, price: 509.00 }, // 52-53kg
      { min: 53001, max: 54000, price: 519.00 }, // 53-54kg
      { min: 54001, max: 55000, price: 529.00 }, // 54-55kg
      { min: 55001, max: 56000, price: 539.00 }, // 55-56kg
      { min: 56001, max: 57000, price: 549.00 }, // 56-57kg
      { min: 57001, max: 58000, price: 559.00 }, // 57-58kg
      { min: 58001, max: 59000, price: 569.00 }, // 58-59kg
      { min: 59001, max: 60000, price: 579.00 }, // 59-60kg
      { min: 60001, max: 61000, price: 589.00 }, // 60-61kg
      { min: 61001, max: 62000, price: 599.00 }, // 61-62kg
      { min: 62001, max: 63000, price: 609.00 }, // 62-63kg
      { min: 63001, max: 64000, price: 619.00 }, // 63-64kg
      { min: 64001, max: 65000, price: 629.00 }, // 64-65kg
      { min: 65001, max: 66000, price: 639.00 }, // 65-66kg
      { min: 66001, max: 67000, price: 649.00 }, // 66-67kg
      { min: 67001, max: 68000, price: 659.00 }, // 67-68kg
      { min: 68001, max: 69000, price: 669.00 }, // 68-69kg
      { min: 69001, max: 70000, price: 679.00 }, // 69-70kg
      { min: 70001, max: 71000, price: 697.00 }, // 70-71kg
      { min: 71001, max: 72000, price: 707.00 }, // 71-72kg
      { min: 72001, max: 73000, price: 717.00 }, // 72-73kg
      { min: 73001, max: 74000, price: 727.00 }, // 73-74kg
      { min: 74001, max: 75000, price: 737.00 }, // 74-75kg
      { min: 75001, max: 76000, price: 747.00 }, // 75-76kg
      { min: 76001, max: 77000, price: 757.00 }, // 76-77kg
      { min: 77001, max: 78000, price: 767.00 }, // 77-78kg
      { min: 78001, max: 79000, price: 777.00 }, // 78-79kg
      { min: 79001, max: 80000, price: 787.00 }, // 79-80kg
      { min: 80001, max: 81000, price: 797.00 }, // 80-81kg
      { min: 81001, max: 82000, price: 807.00 }, // 81-82kg
      { min: 82001, max: 83000, price: 817.00 }, // 82-83kg
      { min: 83001, max: 84000, price: 827.00 }, // 83-84kg
      { min: 84001, max: 85000, price: 837.00 }, // 84-85kg
      { min: 85001, max: 86000, price: 847.00 }, // 85-86kg
      { min: 86001, max: 87000, price: 857.00 }, // 86-87kg
      { min: 87001, max: 88000, price: 867.00 }, // 87-88kg
      { min: 88001, max: 89000, price: 877.00 }, // 88-89kg
      { min: 89001, max: 90000, price: 887.00 }, // 89-90kg
      { min: 90001, max: 91000, price: 897.00 }, // 90-91kg
      { min: 91001, max: 92000, price: 907.00 }, // 91-92kg
      { min: 92001, max: 93000, price: 917.00 }, // 92-93kg
      { min: 93001, max: 94000, price: 927.00 }, // 93-94kg
      { min: 94001, max: 95000, price: 937.00 }, // 94-95kg
      { min: 95001, max: 96000, price: 947.00 }, // 95-96kg
      { min: 96001, max: 97000, price: 957.00 }, // 96-97kg
      { min: 97001, max: 98000, price: 967.00 }, // 97-98kg
      { min: 98001, max: 99000, price: 977.00 }, // 98-99kg
      { min: 99001, max: 100000, price: 987.00 }, // 99-100kg
      { min: 100001, max: 101000, price: 997.00 }, // 100-101kg
      { min: 101001, max: 102000, price: 1007.00 }, // 101-102kg
      { min: 102001, max: 103000, price: 1017.00 }, // 102-103kg
      { min: 103001, max: 104000, price: 1027.00 }, // 103-104kg
      { min: 104001, max: 105000, price: 1037.00 }, // 104-105kg
      { min: 105001, max: 106000, price: 1047.00 }, // 105-106kg
      { min: 106001, max: 107000, price: 1057.00 }, // 106-107kg
      { min: 107001, max: 108000, price: 1067.00 }, // 107-108kg
      { min: 108001, max: 109000, price: 1077.00 }, // 108-109kg
      { min: 109001, max: 110000, price: 1087.00 }, // 109-110kg
      { min: 110001, max: 111000, price: 1097.00 }, // 110-111kg
      { min: 111001, max: 112000, price: 1107.00 }, // 111-112kg
      { min: 112001, max: 113000, price: 1117.00 }, // 112-113kg
      { min: 113001, max: 114000, price: 1127.00 }, // 113-114kg
      { min: 114001, max: 115000, price: 1137.00 }, // 114-115kg
      { min: 115001, max: 116000, price: 1147.00 }, // 115-116kg
      { min: 116001, max: 117000, price: 1157.00 }, // 116-117kg
      { min: 117001, max: 118000, price: 1167.00 }, // 117-118kg
      { min: 118001, max: 119000, price: 1177.00 }, // 118-119kg
      { min: 119001, max: 120000, price: 1187.00 }, // 119-120kg
      { min: 120001, max: 121000, price: 1197.00 }, // 120-121kg
      { min: 121001, max: 122000, price: 1207.00 }, // 121-122kg
      { min: 122001, max: 123000, price: 1217.00 }, // 122-123kg
      { min: 123001, max: 124000, price: 1227.00 }, // 123-124kg
      { min: 124001, max: 125000, price: 1237.00 }, // 124-125kg
      { min: 125001, max: 126000, price: 1247.00 }, // 125-126kg
      { min: 126001, max: 127000, price: 1257.00 }, // 126-127kg
      { min: 127001, max: 128000, price: 1267.00 }, // 127-128kg
      { min: 128001, max: 129000, price: 1277.00 }, // 128-129kg
      { min: 129001, max: 130000, price: 1287.00 }, // 129-130kg
      { min: 130001, max: 131000, price: 1297.00 }, // 130-131kg
      { min: 131001, max: 132000, price: 1307.00 }, // 131-132kg
      { min: 132001, max: 133000, price: 1317.00 }, // 132-133kg ← 您的重量！
      { min: 133001, max: 134000, price: 1327.00 }, // 133-134kg
      { min: 134001, max: 135000, price: 1337.00 }, // 134-135kg
      { min: 135001, max: 136000, price: 1347.00 }, // 135-136kg
      { min: 136001, max: 137000, price: 1357.00 }, // 136-137kg
      { min: 137001, max: 138000, price: 1367.00 }, // 137-138kg
      { min: 138001, max: 139000, price: 1377.00 }, // 138-139kg
      { min: 139001, max: 140000, price: 1387.00 }, // 139-140kg
      { min: 140001, max: 141000, price: 1397.00 }, // 140-141kg
      { min: 141001, max: 142000, price: 1407.00 }, // 141-142kg
      { min: 142001, max: 143000, price: 1417.00 }, // 142-143kg
      { min: 143001, max: 144000, price: 1427.00 }, // 143-144kg
      { min: 144001, max: 145000, price: 1437.00 }, // 144-145kg
      { min: 145001, max: 146000, price: 1447.00 }, // 145-146kg
      { min: 146001, max: 147000, price: 1457.00 }, // 146-147kg
      { min: 147001, max: 148000, price: 1467.00 }, // 147-148kg
      { min: 148001, max: 149000, price: 1477.00 }, // 148-149kg
      { min: 149001, max: 150000, price: 1487.00 }, // 149-150kg
      { min: 150001, max: 151000, price: 1497.00 }, // 150-151kg
      { min: 151001, max: 152000, price: 1507.00 }, // 151-152kg
      { min: 152001, max: 153000, price: 1517.00 }, // 152-153kg
      { min: 153001, max: 154000, price: 1527.00 }, // 153-154kg
      { min: 154001, max: 155000, price: 1537.00 }, // 154-155kg
      { min: 155001, max: 156000, price: 1547.00 }, // 155-156kg
      { min: 156001, max: 157000, price: 1557.00 }, // 156-157kg
      { min: 157001, max: 158000, price: 1567.00 }, // 157-158kg
      { min: 158001, max: 159000, price: 1577.00 }, // 158-159kg
      { min: 159001, max: 160000, price: 1587.00 }, // 159-160kg
      { min: 160001, max: 161000, price: 1597.00 }, // 160-161kg
      { min: 161001, max: 162000, price: 1607.00 }, // 161-162kg
      { min: 162001, max: 163000, price: 1617.00 }, // 162-163kg
      { min: 163001, max: 164000, price: 1627.00 }, // 163-164kg
      { min: 164001, max: 165000, price: 1637.00 }, // 164-165kg
      { min: 165001, max: 166000, price: 1647.00 }, // 165-166kg
      { min: 166001, max: 167000, price: 1657.00 }, // 166-167kg
      { min: 167001, max: 168000, price: 1667.00 }, // 167-168kg
      { min: 168001, max: 169000, price: 1677.00 }, // 168-169kg
      { min: 169001, max: 170000, price: 1687.00 }, // 169-170kg
      { min: 170001, max: 171000, price: 1697.00 }, // 170-171kg
      { min: 171001, max: 172000, price: 1707.00 }, // 171-172kg
      { min: 172001, max: 173000, price: 1717.00 }, // 172-173kg
      { min: 173001, max: 174000, price: 1727.00 }, // 173-174kg
      { min: 174001, max: 175000, price: 1737.00 }, // 174-175kg
      { min: 175001, max: 176000, price: 1747.00 }, // 175-176kg
      { min: 176001, max: 177000, price: 1757.00 }, // 176-177kg
      { min: 177001, max: 178000, price: 1767.00 }, // 177-178kg
      { min: 178001, max: 179000, price: 1777.00 }, // 178-179kg
      { min: 179001, max: 180000, price: 1787.00 }, // 179-180kg
      { min: 180001, max: 181000, price: 1797.00 }, // 180-181kg
      { min: 181001, max: 182000, price: 1807.00 }, // 181-182kg
      { min: 182001, max: 183000, price: 1817.00 }, // 182-183kg
      { min: 183001, max: 184000, price: 1827.00 }, // 183-184kg
      { min: 184001, max: 185000, price: 1837.00 }, // 184-185kg
      { min: 185001, max: 186000, price: 1847.00 }, // 185-186kg
      { min: 186001, max: 187000, price: 1857.00 }, // 186-187kg
      { min: 187001, max: 188000, price: 1867.00 }, // 187-188kg
      { min: 188001, max: 189000, price: 1877.00 }, // 188-189kg
      { min: 189001, max: 190000, price: 1887.00 }, // 189-190kg
      { min: 190001, max: 191000, price: 1897.00 }, // 190-191kg
      { min: 191001, max: 192000, price: 1907.00 }, // 191-192kg
      { min: 192001, max: 193000, price: 1917.00 }, // 192-193kg
      { min: 193001, max: 194000, price: 1927.00 }, // 193-194kg
      { min: 194001, max: 195000, price: 1937.00 }, // 194-195kg
      { min: 195001, max: 196000, price: 1947.00 }, // 195-196kg
      { min: 196001, max: 197000, price: 1957.00 }, // 196-197kg
      { min: 197001, max: 198000, price: 1967.00 }, // 197-198kg
      { min: 198001, max: 199000, price: 1977.00 }, // 198-199kg
      { min: 199001, max: 200000, price: 1987.00 }  // 199-200kg
    ];

    const countryMultipliers = {
      // 亚太地区 - 低系数
      'HK': 0.53,    // 中国香港特别行政区
      'MO': 0.53,    // 中国澳门特别行政区
      'JP': 0.65,    // 日本
      'KR': 0.74,    // 韩国
      'TW': 0.74,    // 中国台湾地区
      'BN': 0.8,     // 文莱
      'ID': 0.8,     // 印度尼西亚
      'KH': 0.8,     // 柬埔寨
      'LA': 0.8,     // 老挝
      'MY': 0.8,     // 马来西亚
      'PH': 0.8,     // 菲律宾
      'SG': 0.8,     // 新加坡
      'TH': 0.8,     // 泰国
      'VN': 0.8,     // 越南
      
      // 大洋洲
      'AU': 0.96,    // 澳大利亚
      'NZ': 0.96,    // 新西兰
      
      // 北美洲
      'CA': 1,       // 加拿大
      'MX': 1,       // 墨西哥
      'US': 1,       // 美国
      
      // 欧洲地区 - 标准系数
      'AD': 1.14, 'AT': 1.14, 'BE': 1.14, 'BG': 1.14, 'CH': 1.14,
      'CY': 1.14, 'CZ': 1.14, 'DE': 1.14, 'DK': 1.14, 'EE': 1.14,
      'ES': 1.14, 'FI': 1.14, 'FR': 1.14, 'GB': 1.14, 'GG': 1.14,
      'GI': 1.14, 'GL': 1.14, 'GR': 1.14, 'HR': 1.14, 'HU': 1.14,
      'IC': 1.14, 'IE': 1.14, 'IN': 1.14, 'IS': 1.14, 'IT': 1.14,
      'JE': 1.14, 'LI': 1.14, 'LT': 1.14, 'LU': 1.14, 'LV': 1.14,
      'MC': 1.14, 'MT': 1.14, 'NL': 1.14, 'NO': 1.14, 'PL': 1.14,
      'PT': 1.14, 'SE': 1.14, 'SI': 1.14, 'SK': 1.14, 'SM': 1.14,
      'VA': 1.14,
      
      // 中东地区
      'AE': 1.45, 'BH': 1.45, 'EG': 1.45, 'IL': 1.45, 'KW': 1.45,
      'SA': 1.45, 'TR': 1.45,
      
      // 其他所有国家 - 高系数 (默认2.02)
      'other': 2.02
    };

    let basePrice = 26.00;

    // 查找对应重量区间的价格
    for (const range of weightRanges) {
      if (weight >= range.min && weight <= range.max) {
        basePrice = range.price;
        break;
      }
    }

    // 🔥 如果超过200kg，使用最高价格
    if (weight > 200000) {
      basePrice = 2000.00;
    }

    // 应用国家系数
    const countryMultiplier = countryMultipliers[country] || 2.02;
    const finalPrice = basePrice * countryMultiplier;

    // 🔥 添加调试日志确认Asset控制运费计算
    console.log(`🔥 Asset计算: 重量=${weight}g, 基础价格=$${basePrice}, 国家=${country}, 系数=${countryMultiplier}, 最终价格=$${finalPrice.toFixed(2)}`);

    return Math.round(finalPrice * 100) / 100;
  }

  getDHLDeliveryTime(country) {
    const deliveryTimes = {
      'HK': '1 business day', 'MO': '1 business day',
      'JP': '1-2 business days', 'KR': '1-2 business days', 'TW': '1-2 business days',
      'SG': '1-2 business days', 'MY': '1-2 business days', 'TH': '1-2 business days',
      'US': '1-3 business days', 'CA': '1-3 business days',
      'GB': '1-2 business days', 'DE': '1-2 business days', 'FR': '1-2 business days',
      'AU': '2-3 business days', 'NZ': '2-3 business days'
    };
    return deliveryTimes[country] || '2-5 business days';
  }

  displayResults(weight, value, country, cost, deliveryTime) {
    const countryNames = {
      'HK': 'Hong Kong', 'MO': 'Macao', 'JP': 'Japan', 'KR': 'South Korea', 'TW': 'Taiwan',
      'US': 'United States', 'CA': 'Canada', 'GB': 'United Kingdom', 'DE': 'Germany', 'FR': 'France',
      'IT': 'Italy', 'ES': 'Spain', 'AU': 'Australia', 'NZ': 'New Zealand', 'SG': 'Singapore',
      'MY': 'Malaysia', 'TH': 'Thailand', 'VN': 'Vietnam'
    };

    document.getElementById('total-weight').textContent = weight + 'g';
    document.getElementById('total-value').textContent = '$' + value.toFixed(2);
    document.getElementById('destination').textContent = countryNames[country] || country;
    document.getElementById('shipping-cost').textContent = '$' + cost.toFixed(2);
    document.getElementById('delivery-time').textContent = deliveryTime;

    const resultsSection = document.getElementById('shipping-results');
    resultsSection.style.display = 'block';
    resultsSection.scrollIntoView({ behavior: 'smooth' });
  }
}

// 全局函数（用于兼容内联事件处理器和调试）
window.clearSearch = function() {
  if (window.dhlCalculator) {
    window.dhlCalculator.resetFilters();
  }
};

window.changeQuantity = function(productId, change) {
  if (window.dhlCalculator) {
    const input = document.querySelector(`input[data-product-id="${productId}"]`);
    if (input) {
      const currentValue = parseInt(input.value) || 0;
      const maxValue = parseInt(input.max) || 99;
      const newValue = Math.max(0, Math.min(maxValue, currentValue + change));
      input.value = newValue;
      input.dispatchEvent(new Event('change'));
    }
  }
};

window.updateProductSelection = function(productId, value) {
  if (window.dhlCalculator) {
    const checkbox = document.getElementById(`product_${productId}`);
    if (checkbox) {
      checkbox.checked = parseInt(value) > 0;
      checkbox.dispatchEvent(new Event('change'));
    }
  }
};

window.toggleSelectAll = function() {
  const selectAllBtn = document.getElementById('select-all');
  if (window.dhlCalculator && selectAllBtn) {
    window.dhlCalculator.toggleSelectAll(selectAllBtn.checked);
  }
};

window.resetFilters = function() {
  if (window.dhlCalculator) {
    window.dhlCalculator.resetFilters();
  }
};

window.proceedToShipping = function() {
  if (window.dhlCalculator) {
    window.dhlCalculator.proceedToShipping();
  }
};

// 🔥 修复：添加缺失的全局函数
window.updateSelection = function() {
  console.log('updateSelection called (legacy function)');
  // 这个函数现在由事件委托处理，但保留以防兼容性问题
};

// 初始化计算器
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔥 Asset file: DOM loaded, initializing calculator...');
  window.dhlCalculator = new DHLShippingCalculator();
});

// 立即初始化（防止DOM已经加载完成）
if (document.readyState !== 'loading') {
  console.log('🔥 Asset file: DOM already loaded, initializing calculator immediately...');
  window.dhlCalculator = new DHLShippingCalculator();
}